/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { Stacklight } from 'templates/pubSub/types/TemplateType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import { usePubSubNode, usePubSubValue } from 'utilities/PubSub/PubSubHooks';

interface IStacklightComponentProps {
  templateContext: TemplateContext;
  stacklight: Stacklight;
  startingNodeId?: NodeIdentifier;
}

export default function StacklightComponent(props: IStacklightComponentProps): ReactElement {
  const signalFilter = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.stacklight.signalVariable?.variablePath,
  );
  const signalNode = usePubSubNode(signalFilter, props.startingNodeId);
  const signalValue = usePubSubValue(signalNode);

  const colorFilter = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.stacklight.colorVariable?.variablePath,
  );
  const colorNode = usePubSubNode(colorFilter, props.startingNodeId);
  const colorValue = usePubSubValue(colorNode);

  const signalOn = signalValue === props.stacklight.signalOffValue ? 'off' : 'on';
  const signalColor = props.stacklight.colorValues[colorValue] || 'off';

  return (
    <>
      {signalColor.startsWith('#') ? (
        <div className="stacklight-item" style={{ backgroundColor: signalColor }} data-signal-on={signalOn} />
      ) : (
        <div className="stacklight-item" data-color={signalColor} data-signal-on={signalOn} />
      )}
    </>
  );
}
